import { useWire } from "~/wire";
import { PageRenderer } from "./PageRenderer";

/**
 * MainContent component that renders the primary content area.
 * This is a thin wrapper around PageRenderer that reads from navigation state.
 */
export const MainContent = () => {
  const wire = useWire();
  const nav = wire.navigation;

  return <PageRenderer id={nav.state().primaryId} />;
};
